import React, { useEffect } from 'react'
//使用router的api oOutlet让这个组件承载 页面子路由内容
import { Outlet, Link, useLocation, useNavigate, useParams } from 'react-router-dom'
export default function App15() {
  //useLocation 返回当前路径
  // useNavigate 跳转api 用于点击后跳转
  //useParams  跳转后获取携带的参数
  const Location = useLocation()
  const Navigate = useNavigate()
  const { id } = useParams()
  console.log('🚀 ~ file: App15.jsx ~ line 11 ~ App15 ~ id', id)
  // 首次加载时如果后缀是/ 跳转到 detail
  useEffect(() => {
    const { pathname } = Location
    if (pathname === '/') {
      Navigate('/home')
    }
  })
  const toDetail = async () => {
    const params = {
      name: 'test6',
      passwd: 123456787,
    }
    try {
      const res = fetch('/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json,text/plain,*/*',
        },
        body: `name=${params.name}&passwd=${params.passwd}`,
      })
      console.log(res.json(), '=<<<<<')
    } catch (error) {}
    // Navigate('/detail')
  }
  console.log(Location, '当前路径')
  return (
    <>
      <ul>
        <li>
          <Link to="/home">首页</Link>
        </li>
        <li>
          <Link to={`/list/${Math.floor(Math.random() * 10)}`}>列表页</Link>
        </li>
        <li>
          <Link to="/detail">详情页</Link>
        </li>
      </ul>
      <button onClick={toDetail}>跳转到详情页112</button>
      <Outlet />
    </>
  )
}
